import { Navigate, useRoutes } from 'react-router-dom';

import { SimpleLayout, DashboardLayout } from 'layouts';

// public
import Login from 'pages/Login';
import ForgotPassword from 'pages/ForgotPassword';
import ResetPassword from 'pages/ResetPassword';
import AcceptInvite from 'pages/AcceptInvite';

// private
import Home from 'pages/Home';
import InvitesInvited from 'pages/Invites/Invited';
import InvitesProvider from 'pages/Invites/Provider';
import TeamList from 'pages/Team/List';
import TeamDetail from 'pages/Team/Detail';
import ClientsInvited from 'pages/Clients/Invited';
import ClientsProvider from 'pages/Clients/Provider';
import ClientsDetail from 'pages/Clients/Detail';
import ContractsCreated from 'pages/Contracts/Created';
import ContractsProvider from 'pages/Contracts/Provider';
import ContractDetail from 'pages/Contracts/Detail';
import ContractsEndedClient from 'pages/Contracts/ClientEndedList';
import ContractClientDetail from 'pages/Contracts/ClientDetail';
import MyProfile from 'pages/MyProfile';
import ContractParams from 'pages/Settings/ContractParams';
import GlobalContractParams from 'pages/Settings/GlobalContractParams';
import CompanyIntegration from 'pages/Settings/CompanyIntegration';
import Terms from 'pages/Settings/Terms';
import Privacy from 'pages/Settings/Privacy';
import TermsPublic from 'pages/Terms';
import ChargesDashboard from 'pages/Charges';

// global
import Page404 from 'pages/404';

// ACL routers
import Public from './Public';
import Private from './Private';

export default function Router() {
  const routes = useRoutes([
    // public routes
    {
      path: 'auth',
      element: <Public />,
      children: [
        { element: <Login />, index: true },
        { path: 'recuperar-senha', element: <ForgotPassword /> },
        { path: 'redefinir-senha/:token', element: <ResetPassword /> },
        { path: 'convite/:token', element: <AcceptInvite /> },
      ],
    },

    // all users routes
    {
      path: '/',
      element: <Private />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { path: '', element: <Home />, index: true },
          ],
        },
      ],
    },

    // superuser routes
    {
      path: '/',
      element: <Private profiles={['superuser']} />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { path: 'configuracoes/contratos', element: <GlobalContractParams /> },
            { path: 'configuracoes/termos', element: <Terms /> },
            { path: 'configuracoes/privacidade', element: <Privacy /> },
          ],
        },
      ],
    },

    // all except superuser routes
    {
      path: '/',
      element: <Private profiles={['admin', 'seller', 'client', 'assistant', 'legal']} />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { path: 'meu-perfil', element: <MyProfile /> },
          ],
        },
      ],
    },

    // admin routes
    {
      path: '/',
      element: <Private profiles={['admin']} />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { path: 'convites/todos', element: <InvitesProvider /> },
            { path: 'clientes/todos', element: <ClientsProvider /> },
            { path: 'clientes/todos/perfil/:id', element: <ClientsDetail /> },
            { path: 'contratos/todos', element: <ContractsProvider /> },
            { path: 'contratos/todos/detalhe/:id', element: <ContractDetail /> },
            { path: 'configuracoes/contrato', element: <ContractParams /> },
            { path: 'configuracoes/integracoes', element: <CompanyIntegration /> },
            { path: 'configuracoes/termos', element: <Terms /> },
            { path: 'configuracoes/privacidade', element: <Privacy /> },
          ],
        },
      ],
    },

    // admin and seller routes
    {
      path: '/',
      element: <Private profiles={['admin', 'seller']} />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { path: 'convites', element: <InvitesInvited /> },
            { path: 'equipe', element: <TeamList /> },
            { path: 'clientes', element: <ClientsInvited /> },
            { path: 'contratos', element: <ContractsCreated /> },
            { path: 'cobrancas', element: <ChargesDashboard /> },
          ],
        },
      ],
    },

    // admin, seller and legal routes
    {
      path: '/',
      element: <Private profiles={['admin', 'seller', 'legal']} />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { path: 'clientes/perfil/:id', element: <ClientsDetail /> },
            { path: 'equipe/perfil/:id', element: <TeamDetail /> },
          ],
        },
      ],
    },

    // admin, seller, assistant and legal routes
    {
      path: '/',
      element: <Private profiles={['admin', 'seller', 'assistant', 'legal']} />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { path: 'contratos/detalhe/:id', element: <ContractDetail /> },
          ],
        },
      ],
    },

    // client routes
    {
      path: '/',
      element: <Private profiles={['client']} />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { path: 'encerrados', element: <ContractsEndedClient /> },
            { path: 'cliente/contrato/:id', element: <ContractClientDetail /> }
          ],
        },
      ],
    },

    // terms routes
    {
      element: <SimpleLayout />,
      children: [
        { path: 'termos-de-uso', element: <TermsPublic /> },
        { path: 'politica-de-privacidade', element: <TermsPublic /> },
      ],
    },

    // 404 routes
    {
      element: <SimpleLayout />,
      children: [
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
